import { CalculBesoinsTab } from "@features/production/components/CalculBesoinsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { BarChart3 } from "lucide-react";

export const Route = createFileRoute("/_app/production/calcul-besoins/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.CBNSAD.VIEW),
  staticData: {
    title: "Calcul des Besoins",
    icon: BarChart3,
    tab_icon: BarChart3,
    permission: PERMISSIONS.PRODUCTION.CBNSAD.VIEW,
    section: "App",
    module: "production",
    order: 30,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Calcul des besoins (CBNSAD)",
  },
  component: CalculBesoinsTab,
});
